// Lettura centralizzata della modalità ambiente.
// Default PROD quando la variabile è assente o diversa da "TRAINING" (comportamento invariato).
export const ENVIRONMENT_MODE = (process.env.REACT_APP_ENVIRONMENT_MODE || "").toUpperCase();
export const IS_TRAINING = ENVIRONMENT_MODE === "TRAINING";
